import { useContext } from "react";
import { PermissionsContext, PermissionsContextType } from "../contexts/permission-context";


export const usePermissions = (): PermissionsContextType => {
  const context = useContext(PermissionsContext) as PermissionsContextType | null;

  if (!context) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }

  return context;
};